export const techStack = [
  {
    title: 'Languages',
    items: [
      { name: 'JavaScript', icon: 'javascript' },
      { name: 'TypeScript', icon: 'typescript' },
      { name: 'Python', icon: 'python' },
      { name: 'Java', icon: 'java' },
      { name: 'Kotlin', icon: 'kotlin' },
      { name: 'C', icon: 'c' },
      { name: 'C++', icon: 'cplusplus' },
      { name: 'C#', icon: 'csharp' },
      { name: 'HTML5', icon: 'html5', dark: true },
      { name: 'CSS3', icon: 'css3', dark: true },
      { name: 'Sass', icon: 'sass' },
      { name: 'SQL', icon: 'sql' },
    ],
  },
  {
    title: 'Frameworks & Libraries',
    items: [
      { name: 'Vue.js', icon: 'vue', dark: true },
      { name: 'Nuxt', icon: 'nuxt' },
      { name: 'Pinia', icon: 'pinia' },
      { name: 'Jest', icon: 'jest' },
      { name: 'Vitest', icon: 'vitest' },
      { name: 'Django', icon: 'django', dark: true },
      { name: 'FastAPI', icon: 'fastapi' },
      { name: 'Spring', icon: 'spring' },
      { name: 'Hibernate', icon: 'hibernate' },
      { name: '.NET', icon: 'dotnet' },
      { name: 'Tailwind', icon: 'tailwind' },
      { name: 'TensorFlow.js', icon: 'tensorflow' },
    ],
  },
  {
    title: 'Tools & Platforms',
    items: [
      { name: 'Git', icon: 'git' },
      { name: 'Docker', icon: 'docker' },
      { name: 'Webpack', icon: 'webpack' },
      { name: 'Vite', icon: 'vite' },
      { name: 'Gradle', icon: 'gradle', dark: true },
      { name: 'Maven', icon: 'maven', dark: true },
      { name: 'Jenkins', icon: 'jenkins' },
      { name: 'Elasticsearch', icon: 'elasticsearch' },
      { name: 'Firebase', icon: 'firebase' },
      { name: 'Node.js', icon: 'nodejs' },
      { name: 'npm', icon: 'npm' },
      { name: 'Storybook', icon: 'storybook' },
    ],
  },
];
